// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "../header/HeaderComponent";
import Footer from "../footer/FooterComponent";
import Seo from "../Seo/SeoComponent";
import BlogSubscribePrompt from "../NewsletterForm/BlogSubscribePrompt";
import { blogPosts } from "../../consts/blogPosts";
import { joyoKanji } from "../../consts/joyoKanji";
import { totalKanjiCount } from "../../consts/allKanjiMeanings";
import styles from "./blogPage.module.scss";
import PageLanguageLink from "../PageLanguageLink/PageLanguageLink";

function formatDate(dateString, locale = "en-US") {
    return new Date(`${dateString}T00:00:00`).toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

function BlogPage() {
    const { t, i18n } = useTranslation("blogPage");
    const isPt = i18n.language === "pt";
    const switchPath = isPt ? "/blog" : "/pt/blog";
    const currentPath = isPt ? "/pt/blog" : "/blog";
    const sortedPosts = [...blogPosts].sort((a, b) => (a.date < b.date ? 1 : -1));
    const counts = {
        joyoCount: joyoKanji.length.toLocaleString("pt-PT"),
        totalCount: totalKanjiCount.toLocaleString("pt-PT"),
    };
    const posts = isPt
        ? sortedPosts
              .filter((post) => !post.ptSlug)
              .map((post) =>
                  post.lang === "pt-PT"
                      ? { ...post, path: `/blog/${post.slug}` }
                      : {
                            ...post,
                            path: `/pt/blog/${post.slug}`,
                            title: t(`posts.${post.slug}.title`, { defaultValue: post.title, ...counts }),
                            excerpt: t(`posts.${post.slug}.excerpt`, { defaultValue: post.excerpt, ...counts }),
                            tags: post.tags?.map((tag) => t(`tags.${tag}`, { defaultValue: tag })),
                        }
              )
        : sortedPosts.map((post) => ({ ...post, path: `/blog/${post.slug}` }));

    return (
        <div className={styles.page}>
            <Seo
                title={t("seoTitle")}
                description={t("seoDescription")}
                path={currentPath}
                lang={isPt ? "pt-PT" : undefined}
            />
            <Header />

            <main className={styles.main}>
                <section className={styles.container}>
                    <h1 className={styles.title}>{t("title")}</h1>
                    <p className={styles.description}>{t("description")}</p>
                    <a href="/rss.xml" className={styles.rssLink}>
                        {t("rssFeed")}
                    </a>

                    <div className={styles.postList}>
                        {posts.map((post) => (
                            <Link key={post.slug} to={post.path} className={styles.postCard} lang={post.lang}>
                                <div className={styles.postMeta}>
                                    <time dateTime={post.date}>{formatDate(post.date, isPt ? "pt-PT" : "en-US")}</time>
                                    {post.tags?.map((tag) => (
                                        <span key={tag} className={styles.postTag}>
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                                <h2 className={styles.postTitle}>{post.title}</h2>
                                <p className={styles.postExcerpt}>{post.excerpt}</p>
                                <span className={styles.readMore}>{t("readMore")}</span>
                            </Link>
                        ))}
                    </div>

                    <BlogSubscribePrompt />

                    <PageLanguageLink to={switchPath} />
                </section>
            </main>

            <Footer />
        </div>
    );
}

export default BlogPage;
